module.exports = __webpack_public_path__ + "img/9-6.1bc2f143.jpg";